import React from 'react';
import { useSelector } from 'react-redux';
import NoImage from '../../../assets/images/no-image.png';

const HotelDetails = ({hotelItem, resourceKeys}) => {
    
    const currency = useSelector(
        (state) => state.currencyDetails.currentCurrency
      );
      
    return (
        <>
            <div className="box_wrap SPdetWrap common_bdrBtm w-100 p-4">
                    <h4 className="SPdethead">{resourceKeys.your_hotel || 'Your Hotel'}</h4>
                    <div className="itenary-item">
                        <div className="itenary-head d-flex flex-wrap align-items-center">
                        <div className="itenary-day-label">{resourceKeys.Day || 'Day'} {hotelItem?.DayNo}</div>
                        <h3>
                            {hotelItem?.HotelName}<span></span>
                        </h3>
                        </div>
                        {hotelItem?.Rooms?.map((room) => (
                            <div className="hotel-room-details" key={room?.RoomId}>
                            <div className="row">
                                <div className="col-lg-1 col-md-2 col-4 hotel-room-thumb pl-0">
                                <img
                                    src={
                                        hotelItem?.Image[0]
                                        ? hotelItem.Image[0]
                                        : NoImage
                                    }
                                    alt={hotelItem?.HotelName || "Hotel Image"}
                                    className="hotel-image"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = NoImage;
                                    }}
                                    />

                                </div>
                                <div className="col-lg-4 col-md-6 col-8 room-details-listing">
                                <h5>{room?.RoomName} {resourceKeys.room || 'room'}</h5>
                                <span>{resourceKeys.board_type || 'Board Type'}: {room?.BoardType || 'NA'}</span>
                                </div>
                                <div className="col-lg-2 col-md-6 col-6 d-flex align-items-center room-details-listing">
                                <ul className="spHtlDtls">
                                    <li>
                                    <i className="htladultIcon" />
                                    <span>{room?.MaxAdult} {resourceKeys.Adult || 'Adult'}</span>
                                    </li>
                                    <li>
                                    <i className="htlchildIcon" />
                                    <span>{room?.MaxChild} {resourceKeys.Child || 'Child'}</span>
                                    </li>
                                </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6 d-flex align-items-center room-details-price">
                                <span>
                                    <span>{currency}</span> <span>{room?.Price}</span>
                                </span>
                                </div>
                                {/* <div className="col-lg-2 col-md-6 col-sm-6 d-flex align-items-center justify-content-end room-select pr-0">
                                <span className="theme_btnStyle ">{resourceKeys.Selected || 'Selected'}</span>
                                </div> */}
                            </div>
                            </div>
                        ))}

                    </div>
                    </div>
        </>
    );
}

export default HotelDetails;
